import { Injectable } from "@angular/core";
import { Config } from "../../../config/config";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class CredenciamentoAplicativoService {
    private _config: Config = new Config();

    constructor(private http: HttpClient) { }

    public listar(filter: any, page: any = '1', perPage: number = 10): Observable<any> {
        let httpParams = new HttpParams();
        httpParams = httpParams.append('page', page)
        return this.http.post(`${this._config.get('urlServiceBackend')}credenciais/aplicativo/listar/${perPage}`, filter, {
            params: httpParams
        })
    }

    public cadastrar(data: any): Observable<any> {
        return this.http.post(`${this._config.get('urlServiceBackend')}credenciais/aplicativo/cadastrar`, data)
    }

    public atualizar(id: any, data: any): Observable<any> {
        return this.http.post(`${this._config.get('urlServiceBackend')}credenciais/aplicativo/${id}/atualizar`, data)
    }

    public deletar(id: any): Observable<any> {
        return this.http.delete(`${this._config.get('urlServiceBackend')}credenciais/aplicativo/${id}/deletar`)
    }
}
